module.exports = __webpack_public_path__ + "static/media/image18.d3d62f8c.jpg";